import {
  Box,
  FormControl,
  Stack,
  TextField,
  IconButton,
  useTheme,
  Switch,
  Typography,
  useMediaQuery
} from '@mui/material';
import { styled } from '@mui/material/styles';
import SearchTwoToneIcon from '@mui/icons-material/SearchTwoTone';
import { KeyboardEvent, useMemo, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'src/app/hooks';
import DateRangeLabel from '../../components/DateRangeLabel';
import ClearIcon from '@mui/icons-material/Clear';
import useOnlineMedia from 'src/services/useOnlineMedia';
import { fillParamAdvanceSearchEmpty } from 'src/utils/fillParamAdvanceSearchEmpth';
import { IGranularity } from 'src/models/general';
import { reducerUpdateAdvanceSearchOfflineMediaPhrases } from 'src/features/advanceSearchOfflineMedia';
import Information from 'src/components/Information';
import { reducerUpdateIncludeClipping } from 'src/features/offlineMediaStream';
import useQueryUrl from 'src/hooks/useQuery';
import SelectDateRangeRetail from 'src/components/Retail/SelectDateRangeRetail';

const CustomBox = styled(Box)(
  ({ theme }) => `
    // width: calc(100vw - ${theme.sidebar.width} - ${theme.spacing(10)});
    margin: ${theme.spacing(2, 0)};
    // position: absolute;
`
);

const FilterBox = styled(Box)(
  ({ theme }) => `
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`
);

function BottomHeader() {
  const theme = useTheme();
  const [localSearch, setLocalSearch] = useState<string>('');
  const dispatch = useAppDispatch();
  const advanceSearchOnlineMedia = useAppSelector(
    (state) => state.storeAdvanceSearchOnlineMedia
  );
  const projectId = useAppSelector((state) => state.users.project.id);
  const { dateRangeFormatted } = useAppSelector(
    (state) => state.analyticArguments
  );
  const { includeClipping } = useAppSelector(
    (state) => state.storeOfflineMediaStream
  );

  const fillAdvanceSearchOnlineMedia = useMemo(() => {
    return fillParamAdvanceSearchEmpty(advanceSearchOnlineMedia);
  }, [advanceSearchOnlineMedia]);

  const { getAllMetricStatistic } = useOnlineMedia();

  const granularity: IGranularity = {
    unit: 'day',
    value: 1
  };
  const timezone = useAppSelector((state) => state.users.project.timezone);

  const finalPayload = {
    ...fillAdvanceSearchOnlineMedia,
    projectId,
    ...dateRangeFormatted,
    granularity,
    timezone,
    page: 1,
    limit: 20
  };

  const handleSearch = () => {
    // getAllMetricStatistic({ ...finalPayload, phrases: [localSearch] });
    dispatch(reducerUpdateAdvanceSearchOfflineMediaPhrases([localSearch]));
    // console.log('phrase entered');
  };

  const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter') handleSearch();
  };

  const handleClear = () => {
    setLocalSearch('');
    dispatch(reducerUpdateAdvanceSearchOfflineMediaPhrases([]));
  };

  const handleRefresh = () => {
    // getAllMetricStatistic(finalPayload);
  };

  const matchesUpMd = useMediaQuery(theme.breakpoints.up('md'));

  const handleSwitchToggleStreamOrClipping = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    dispatch(reducerUpdateIncludeClipping(event.target.checked));
  };

  return (
    <CustomBox>
      <FilterBox gap={1}>
        <Stack direction="row" alignItems="center" spacing={2}>
          <TextField
            size="small"
            sx={{ width: { xs: '100%', md: 400 } }}
            InputProps={{
              startAdornment: (
                <IconButton size="small" onClick={handleSearch}>
                  <SearchTwoToneIcon htmlColor="#757575" />
                </IconButton>
              ),
              sx: { borderRadius: '16px', backgroundColor: 'white' },
              endAdornment: localSearch ? (
                <IconButton size="small" onClick={handleClear}>
                  <ClearIcon />
                </IconButton>
              ) : null
            }}
            placeholder="Search media"
            onChange={(e) => setLocalSearch(e.target.value)}
            value={localSearch}
            onKeyDown={handleKeyDown}
          />
          <FormControl size="small" sx={{ width: 135 }}>
            <SelectDateRangeRetail
              selectProps={{
                sx: {
                  borderRadius: '16px',
                  width: '135px'
                }
              }}
            />
          </FormControl>
        </Stack>
        <Stack direction={'row'} spacing={1}>
          {matchesUpMd && timezone === 7 && (
            <Stack direction="row" spacing={1} alignItems="center">
              <Typography fontSize="13px">All Streams</Typography>
              <Switch
                name="streamOrClipping"
                checked={includeClipping}
                onChange={handleSwitchToggleStreamOrClipping}
              />
              <Typography fontSize="13px">All Clippings Only</Typography>
              <Information content="Showing data from all clipping only." />
            </Stack>
          )}
          {/* <TooltipCustomize title="Refresh all metric" placement="top-start">
            <Button
              variant="contained"
              onClick={handleRefresh}
              sx={{
                borderRadius: '6px',
                height: theme.spacing(5),
                minWidth: theme.spacing(6),
                background: theme.palette.primary.main
              }}
            >
              <RefreshIcon />
            </Button>
          </TooltipCustomize> */}
        </Stack>
      </FilterBox>
      {!matchesUpMd && timezone === 7 && (
        <Stack
          direction="row"
          spacing={1}
          alignItems="center"
          sx={{ marginTop: '16px' }}
        >
          <Typography fontSize="13px">All Streams</Typography>
          <Switch
            name="streamOrClipping"
            checked={includeClipping}
            onChange={handleSwitchToggleStreamOrClipping}
          />
          <Typography fontSize="13px">All Clippings Only</Typography>
          <Information content="Showing data from all clipping only." />
        </Stack>
      )}
      <DateRangeLabel label={`Viewing data within`} />
    </CustomBox>
  );
}

export default BottomHeader;
